// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3Lc8J","title":"BackImages_title__fR9qQ","images":"BackImages_images__3T4P7"};